var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hotEventScatter"},[_c('div',{ref:"myScatter",staticClass:"myScatter"})])
}
var staticRenderFns = []

export { render, staticRenderFns }